module.exports = __webpack_public_path__ + "img/contratti-rivenditori.c6feb74f.svg";